//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MetricsService from '@/apps/data-platform/services/reports/monitoring_driver_connection';
export default {
  name: 'AttributeMetrics',
  data: function data() {
    return {
      dashboardUrl: '',
      report: null,
      maintenance: true
    };
  },
  created: function created() {
    this.getReport();
  },
  methods: {
    getReport: function getReport() {
      var _this = this;
      MetricsService.get_attribute_report().then(function (response) {
        _this.report = response.data;
        _this.dashboardUrl = _this.report.link + '?params={' + '"v1":"' + _this.report.code + '"}';
        _this.maintenance = _this.report.maintenance;
        console.log(_this.dashboardUrl, 'dashboardUrl');
      });
    }
  },
  computed: {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.somos1_reports'),
        disabled: true,
        href: '/#/customer_insights/'
      }, {
        text: this.$route.params.title,
        disabled: false,
        href: '/#/customer_insights/' + this.$route.params.link
      }];
    }
  }
};